<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <p class="f14">当前买手店：{{ vendorName }}</p>

    <el-form class="mt15" label-position="right" label-width="80px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="名称">
                <el-input v-model.trim="queryForm.promotionEventName" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="状态">
                <el-select v-model="queryForm.statusList" multiple>
                  <el-option label="招商未开始" :value="1"></el-option>
                  <el-option label="招商进行中" :value="2"></el-option>
                  <el-option label="招商已截止" :value="3"></el-option>
                  <el-option label="活动预热中" :value="6"></el-option>
                  <el-option label="活动进行中" :value="4"></el-option>
                  <el-option label="活动已结束" :value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button @click="search" type="primary">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-table :data="tableData">
      <el-table-column prop="promotionTitleCn" label="招商活动名称"></el-table-column>
      <el-table-column prop="investmentStartTime" label="招商时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.investmentStartTime) }} ~ {{ dateFormat(scope.row.investmentEndTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="investmentStartTime" label="活动时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.activityStartTime) }} ~ {{ dateFormat(scope.row.activityEndTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <template v-if="scope.row.status === 1">
            <span class="status-point"></span>
            招商未开始
          </template>
          <template v-if="scope.row.status === 2">
            <span class="status-point"></span>
            招商进行中
          </template>
          <template v-if="scope.row.status === 3">
            <span class="status-point"></span>
            招商已截止
          </template>
          <template v-if="scope.row.status === 6">
            <span class="status-point green"></span>
            活动预热中
          </template>
          <template v-if="scope.row.status === 4">
            <span class="status-point green"></span>
            活动进行中
          </template>
          <template v-if="scope.row.status === 5">
            <span class="status-point gray"></span>
            活动已结束
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.status !== 1" @click="settingItem(scope.row)">活动折扣管理</el-link>
          <el-link type="primary" class="ml10" v-if="subVendorIs != '1' && scope.row.status !== 1" @click="copyItem(scope.row)">复制</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr mt10"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog title="复制" :visible.sync="dialogVisible" append-to-body :close-on-click-modal='false' width="800px" v-loading="detailLoading">
      <p class="f14">选择活动</p>
      <el-radio-group v-model="form.copySalesPromotionId" @change="onChangeCopyPromotion">
        <el-radio class="mt10" v-for="item in salesPromotionVOList" :label="item.salesPromotionId" :key="item.salesPromotionId">{{ item.promotionTitleCn }}</el-radio>
      </el-radio-group>
      <template v-if="form.vendorSelectFlag">
        <div class="mt30">
          <el-button type="primary" plain size="small" @click="form.vendorIdList = vendorList.map(item => item.vendorId)">选择所有店铺</el-button>
          <el-button type="primary" plain size="small" @click="form.vendorIdList = []">取消全部</el-button>
        </div>
        <el-checkbox-group v-model="form.vendorIdList">
          <el-checkbox class="mt10" v-for="item in vendorList" :label="item.vendorId" :key="item.vendorId" :disabled="form.copySalesPromotionId === form.salesPromotionId && item.vendorId == $route.params.id">{{ item.vendorName }}</el-checkbox>
        </el-checkbox-group>
      </template>
      <div class="mt30">
        <el-button type="primary" plain size="small"
          @click="form.adultSeasonList=adultSeasonList.map(item => item);form.kidsSeasonList=kidsSeasonList.map(item => item)"
        >选择所有活动折扣</el-button>
        <el-button type="primary" plain size="small" @click="form.adultSeasonList=[];form.kidsSeasonList=[]">取消全部</el-button>
      </div>
      <p class="mt10 f14">Adult</p>
      <el-checkbox-group v-model="form.adultSeasonList">
        <el-checkbox class="mt10" v-for="item in adultSeasonList" :label="item" :key="item.seasonCode">{{ item.seasonCode }}{{ item.coFlag ? '(CO)' : '' }}</el-checkbox>
      </el-checkbox-group>
      <p class="mt10 f14">Kids</p>
      <el-checkbox-group v-model="form.kidsSeasonList">
        <el-checkbox class="mt10" v-for="item in kidsSeasonList" :label="item" :key="item.seasonCode">{{ item.seasonCode }}{{ item.coFlag ? '(CO)' : '' }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/util.js'
import {
  getVendorPromotionList,
  getVendorPromotionDetail,
  copyVendorPromotion,
} from "../api.js";

export default {
  data() {
    return {
      fullscreenLoading: false,
      vendorName: this.$route.query.name,
      subVendorIs: this.$route.query.subVendorIs,
      queryForm: {
        promotionEventName: null,
        statusList: [2, 3, 4, 6],
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      detailLoading: false,
      salesPromotionVOList: [],
      vendorList: [],
      adultSeasonList: [],
      kidsSeasonList: [],
      form: {
        salesPromotionId: null,
        copySalesPromotionId: null,
        vendorIdList: [],
        adultSeasonList: [],
        kidsSeasonList: [],
        vendorSelectFlag: true,
      },
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.promotionEventName = null;
      this.queryForm.statusList = [2, 3, 4, 6];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getVendorPromotionList(this.$route.params.id, this.queryForm).then(res => {
        if (res.data) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm');
    },
    settingItem(row) {
      let routeData = this.$router.resolve({
        path: `/discount/promotion/manage/${this.$route.params.id}/${row.salesPromotionId}`,
        query: {
          name: this.vendorName,
          eventName: row.promotionTitleCn,
          coFlag: this.$route.query.coFlag,
          activityStartTime: row.activityStartTime,
          subVendorIs: this.subVendorIs,
          status: row.status,
        }
      });
      window.open(routeData.href, "_blank");
    },
    copyItem(row) {
      this.salesPromotionVOList = [];
      this.vendorList = [];
      this.adultSeasonList = [];
      this.kidsSeasonList = [];

      this.form.salesPromotionId = row.salesPromotionId;
      this.form.copySalesPromotionId = null;
      this.form.vendorIdList = [];
      this.form.adultSeasonList = [];
      this.form.kidsSeasonList = [];

      this.dialogVisible = true;

      this.detailLoading = true;
      getVendorPromotionDetail(this.$route.params.id, row.salesPromotionId).then(res => {
        if (res.success) {
          this.form.vendorSelectFlag = res.data.vendorSelectFlag;
          if (this.subVendorIs != '1' && res.data.vendorSelectFla) {
            this.form.copySalesPromotionId = row.salesPromotionId;
          }
          this.salesPromotionVOList = res.data.salesPromotionVOList || [];
          this.vendorList = res.data.vendorList || [];
          this.adultSeasonList = res.data.adultSeasonList || [];
          this.kidsSeasonList = res.data.kidsSeasonList || [];
        } else {
          this.$message.error(res.message || '系统异常，请稍后再试');
        }
        this.detailLoading = false;
      })
    },
    async submit() {
      if (!this.form.copySalesPromotionId) {
        this.$message('请选择要复制的活动');
        return;
      }
      if (this.form.vendorSelectFlag && !this.form.vendorIdList.length) {
        this.$message('请选择至少一个买手店');
        return;
      }
      if (!this.form.adultSeasonList.length && !this.form.kidsSeasonList.length) {
        this.$message('请选择至少一个季节');
        return;
      }
      const result = await this.$confirm('是否确认复制？', '提示', {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
      });
      if (!result) {
        return;
      }
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.fullscreenLoading = true;
      copyVendorPromotion(this.$route.params.id, this.form.salesPromotionId, this.form).then(res => {
        this.fullscreenLoading = false;
        if (res.success) {
          this.$message.success('复制成功');
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.message || '系统异常，请稍后再试');
        }
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      }).catch(() => {
        this.fullscreenLoading = false;
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      });
    },
    onChangeCopyPromotion() {
      if (this.form.copySalesPromotionId === this.form.salesPromotionId && this.form.vendorIdList.includes(Number(this.$route.params.id))) {
        this.form.vendorIdList.splice(this.form.vendorIdList.indexOf(Number(this.$route.params.id)), 1);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.f14 {
  font-size: 14px;
}
.red {
  color: #F56C6C;
}
.gray {
  color: #909399;
}
.pl10 {
  padding-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.mt15 {
  margin-top: 15px;
}
.mt20 {
  margin-top: 20px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.tr {
  text-align: right;
}
.shoppe {
  padding: 20px;
}
.status-point {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 3px;
  background-color: #F56C6C;
  border-radius: 6px;

  &.green {
    background-color: #67C23A;
  }
  &.gray {
    background-color: #909399;
  }
}
.mt30 {
  margin-top: 30px;
}
</style>
